
const routes = {
    LOGIN:'/login',
    DASHBOARD:'/dashboard',
    CAMPAIGN:'/campaign',
    FINANCES:'/finances',
    ACTIVITY:'/activity',
    GAME_CONTEST:'/game-contest',
    TICKET:'/ticket',
    REPORT:'/report',
    BRIEFS_RULES:'/briefs-rules',
    API_CONNECT:'/api-connect',
    SETTINGS:'/settings',
    HELP_SUPPORT:'/help-support',
    ADMIN_USERS:'/adminusers',
    CLASSIC_USERS:'/classicuser',
    CREATORS:'/creators',
    PRODUCTS:'/products',
    GIFTS:'/gifts',
    ITEMS:'/linkitems',
    SELFIES:'/selfies',
    CART:'/usercart',
    BRANDS:'/brands',
    CATEGORIES:'/categories',
    SUBCATEGORIES:'/subcategories',
    ROLES:'/role',
    CREDIT_CODES:'/creditcode',
    NOTIFICATION:'/notification',










  
}
export default routes